import React, { useEffect, useState } from 'react';
import s from './TodaysTrends.module.css';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { getTrendingTopics } from '../../../store/slices/onboardingSlice';
import {
    selectTrendingTopics,
    selectIsLoadingTrendingTopics,
} from '../../../store/selectors/onboardingSelector';

const TodaysTrends: React.FC = () => {
    const dispatch = useAppDispatch();
    const trends = useSelector(selectTrendingTopics);
    const isLoading = useSelector(selectIsLoadingTrendingTopics);
    const [expandedMap, setExpandedMap] = useState<Record<string, boolean>>({});

    const toggleExpand = (id: string) => {
        setExpandedMap((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    return (
        <div className={s.container}>
            {isLoading && <p className={s.loading}>Loading...</p>}
            {!isLoading && (
                <div className={s.list}>
                    {trends && trends.length > 0 ? (
                        trends.map((trend) => {
                            const expanded = !!expandedMap[trend.id];
                            return (
                                <div key={trend.id} className={s.itemGroup}>
                                    <div className={`${s.item} ${expanded ? s.itemExpanded : ''}`}>
                                        {trend.title}
                                    </div>
                                    <span
                                        className={s.readMoreButton}
                                        onClick={() => toggleExpand(trend.id)}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        {expanded ? 'Close' : 'Read more'}
                                    </span>
                                </div>
                            );
                        })
                    ) : (
                        <p className={s.empty}>No trends found</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default TodaysTrends;
